import(/* webpackMode: "eager" */ "/home/runner/work/fulcrum-foundation/fulcrum-foundation/app/global-error.tsx");
